import React from "react";
import "./exam-doc.scss";

const Rules = () => {
  return (
    <div className="exam-doc p-6 max-w-4xl mx-auto text-gray-900 leading-relaxed space-y-4">
      <p className="text-2xl font-bold text-center">
        Эрүүл мэндийн сайдын 2019 оны 11 сарын 15-ны өдрийн А/513 дугаар тушаалын 1 дүгээр хавсралт
      </p>
      <h2 className="text-xl font-semibold text-center mt-2">
        Мэргэшлийн зэрэг олгох, нөхөн олгох, хүчингүй болгох журам
      </h2>

      <section>
        <h3 className="text-lg font-semibold">Мэргэшлийн зэргийн шатлал, чиглэл, хугацаа</h3>
        <p>
          Эмнэлгийн мэргэжилтний мэргэшлийн зэрэг нь “Ахлах”, “Тэргүүлэх”, “Зөвлөх” гэсэн 3 шатлалтай байна.
        </p>
        <p>
          1. Ахлах зэрэгтэй эмнэлгийн мэргэжилтэн нь тухайн мэргэжил, үндсэн мэргэшлийн чиглэлээрх нийтлэг болон
          тусгай шаардлагыг хангасан, байгууллагын бусад эмнэлгийн мэргэжилтэнд зөвлөж хамтран ажиллах, тэдний
          хөгжилд хувь нэмэр оруулах ур чадвартай байна.
        </p>
        <p>
          2. Тэргүүлэх зэрэгтэй эмнэлгийн мэргэжилтэн нь тухайн мэргэжил, мэргэшлийн чиглэлээрх нийтлэг болон тусгай
          шаардлагыг хангасан, бүс, орон нутгийн эмнэлгийн мэргэжилтэнд зөвлөх, тэдний хөгжилд хувь нэмэр оруулах ур
          чадвартай байна.
        </p>
        <p>
          3. Зөвлөх зэрэгтэй эмнэлгийн мэргэжилтэн нь тухайн мэргэжил, мэргэшлийн чиглэлээрх нийтлэг болон тусгай
          шаардлагыг хангасан, салбар, үндэсний түвшинд бусад эмнэлгийн мэргэжилтэнд зөвлөх, тэдний хөгжилд хувь
          нэмэр оруулах ур чадвартай манлайлагч байна.
        </p>
        <p>Мэргэшлийн зэрэг хоорондох шатлал ахиулах хугацаа 5 ба түүнээс дээш жил байна.</p>
        <p>Мэргэшлийн зэргийг шатлал алгасуулан олгохгүй.</p>
        <p>Дор дурдсан үндэслэлийг албан ёсны бичиг баримтаар нотолсон тохиолдолд тасралтгүй ажилласан жилд оруулж тооцно:</p>
        <ul className="list-disc ml-6">
          <li>Жирэмсний болон амаржсаны амралттай, хүүхэд асрах чөлөөтэй;</li>
          <li>Цэргийн жинхэнэ алба хаасан, энхийг сахиулах ажиллагаанд оролцсон;</li>
          <li>Өөрийн болон гэр бүлийн гишүүний биеийн эрүүл мэндийн байдлын улмаас мэргэжлээрээ ажиллахгүйгээр эмчлүүлж, сувилуулсан;</li>
          <li>Эмнэлгийн шинжилгээ хийлгэсэн, донорын үүрэг гүйцэтгэсэн;</li>
          <li>Гадаад улсад мэргэжил, мэргэшлээрээ суралцсан, магистр, докторын сургалтад хамрагдсан;</li>
          <li>Удирдах дээд байгууллага, албан тушаалтны шийдвэрээр өөр ажил үүрэг гүйцэтгэсэн, төрийн байгууллагын сонгуульт үүрэг гурван сар хүртэл хугацаагаар гүйцэтгэсэн;</li>
          <li>Төгсөлтийн дараах мэргэшүүлэх, мэргэжил дээшлүүлэх сургалтад суралцсан.</li>
        </ul>
        <p>
          Эмнэлгийн мэргэжилтэнд мэргэшлийн зэрэг давхцуулан олгохгүй бөгөөд зөвхөн ажиллаж буй мэргэжил, үндсэн ба
          төрөлжсөн мэргэшлийн чиглэлийн аль нэг чиглэлээр мэргэшлийн зэрэг шатлан олгоно.
        </p>
        <p>
          Эрүүл мэндийн байгууллагын удирдлага, сургалт, эрдэм шинжилгээ, хүний нөөц, тусламж, үйлчилгээний чанарын
          албанд ажиллаж байгаа эмнэлгийн мэргэжилтний мэргэшлийн зэргийг хүчинтэйд тооцох бөгөөд энэхүү журамд
          заасны дагуу мэргэшлийн зэргийг давтан хамгаалж, ахиулна.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-semibold">Мэргэшлийн зэрэг горилогчийн бүрдүүлэх баримт бичиг</h3>
        <p>
          Эрүүл мэндийн байгууллага нь мэргэшлийн зэргийн шалгалтад орохыг дэмжсэн эмнэлгийн мэргэжилтний дараах
          баримт бичгийг бүрдүүлж, мэргэжлийн нийгэмлэг, холбоонд хүргүүлнэ. Үүнд:
        </p>
        <ul className="list-disc ml-6">
          <li>Мэргэшлийн зэргийн шалгалтад орохыг хүссэн хувийн өргөдөл;</li>
          <li>Байгууллагын даргын баталгаажуулсан мэргэшлийн зэрэг горилогчийн бүрэн бөглөсөн маягт (Эрүүл мэндийн хөгжлийн төвийн ерөнхий захирлын шийдвэрээр баталгаажуулсан загвараар);</li>
          <li>Орон нутгийн эмнэлгийн мэргэжилтний тухайд харьяалах аймаг, нийслэлийн Эрүүл мэндийн газраас дэмжсэн тодорхойлолт, албан бичиг;</li>
          <li>Нийтлэг болон тусгай шаардлагыг хангасныг баталгаажуулах баримт бичиг;</li>
          <li>Мэргэшлийн зэрэг өмнө нь хамгаалсан бол шийдвэр, үнэмлэхийн хуулбар;</li>
          <li>Иргэний үнэмлэхний хуулбар;</li>
          <li>3х4 хэмжээний зураг 2 хувь (сүүлийн 6 сард авахуулсан).</li>
        </ul>
      </section>

      <section>
        <h3 className="text-lg font-semibold">Мэргэшлийн зэргийн шалгалтын тов, мэргэшлийн зэрэг олгох үе шат</h3>
        <p>
          Мэргэшлийн зэргийн шалгалтыг жил бүрийн 04 дүгээр сарын 15-ны өдрөөс 06 дугаар сарын 15-ны өдөрт багтаан
          зөвхөн нэг удаа зохион байгуулна.
        </p>
        <p>Мэргэшлийн зэргийн шалгалт дараах үе шаттай явагдана. Үүнд:</p>
        <ul className="list-disc ml-6">
          <li>Шалгалтын бэлтгэл ажлыг хангах, бүртгэлийн үйл ажиллагааг зохион байгуулах;</li>
          <li>Шалгалтын комиссыг томилох;</li>
          <li>Шалгалт зохион байгуулах;</li>
          <li>Шалгалтын гүйцэтгэлийг дүгнэх, мэдээлэх;</li>
          <li>Шийдвэр гаргах;</li>
          <li>Шалгалттай холбоотой гомдол шийдвэрлэх.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-lg font-semibold">Бичиг баримт хүргүүлэх хугацаа</h3>
        <p>
          Эрүүл мэндийн байгууллага нь жил бүрийн 02 дугаар сарын 01-ний өдөрт багтаан мэргэшлийн зэргийн шалгалтад
          орохыг дэмжсэн эмнэлгийн мэргэжилтний баримт бичгийг мэргэжлийн нийгэмлэг, холбоонд нэгдсэн журмаар албан
          бичгээр хүргүүлнэ.
        </p>
        <p>
          Мэргэжлийн нийгэмлэг, холбоо нь эрүүл мэндийн байгууллагаас ирүүлсэн баримт бичгийг хянаж, мэргэшлийн зэрэг
          горилогчид тавигдах нийтлэг ба тусгай шаардлага хангасан эмнэлгийн мэргэжилтний нэрсийн жагсаалтыг
          холбогдох баримт бичгийн хамт жил бүрийн 03 дугаар сарын 01-ний өдөрт багтаан ажлын албанд хүргүүлнэ.
        </p>
      </section>
    </div>
  );
};

export default Rules;
  